import { Form } from "components/organisms";
import { FormikHelpers } from "formik";
import middleware from "middleware";
import { useStoreState } from "providers/StoreStateContext";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetUserSpecifications,
  useUpdateUserSpecification,
} from "services/configuration/notifications";
import {
  INotificationSettingsForm,
} from "services/configuration/notifications/types";

const Notifications = () => {
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const getUserSpecifications = useGetUserSpecifications();
  const updateUserSpecification = useUpdateUserSpecification();

  const { tokenData } = useStoreState();
  const navigate = useNavigate();

  const onUpdateUserSpecification = async (
    values: INotificationSettingsForm,
    helpers: FormikHelpers<INotificationSettingsForm>
  ) => {
    const userSpecifications =
      middleware.settings.userSpecification.formToQuery(
        values,
        tokenData?.UserId ?? ""
      ).userSpecifications;
    await updateUserSpecification.mutateAsync(userSpecifications, {
      onSuccess: () => getUserSpecifications.refetch(),
    });
  };

  const mergedNotifications = useMemo(() => {
    if (
      getUserSpecifications.data &&
      getUserSpecifications.data.userSpecifications
    ) {
      const hasAnyEnabledNotifications = getUserSpecifications.data.userSpecifications.some(
        (spec) => spec.enabled === true
      );
      
      setIsUpdate(hasAnyEnabledNotifications);
      
      return middleware.settings.userSpecification.queryToForm(
        getUserSpecifications.data.userSpecifications
      );
    }
    return {};
  }, [getUserSpecifications.data]);

  return (
    <Form.NotificationSettings
      status={{
        isLoading: getUserSpecifications.isLoading,
        displayMode: false,
      }}
      initialValues={{ mockedNotifications: { ...mergedNotifications } }}
      i18nextPrefix="settings"
      onSubmit={
        onUpdateUserSpecification
      }
    />
  );
};

export default Notifications;
